import type { JoinRequestMirror } from '../orgs/orgs.types';

/**
 * True for a verified, non-staff user with no membership at all whose
 * `users/{uid}.joinRequest` mirror exists, whatever its status.
 *
 * `approved` is included on purpose: the mirror can say so before the ID
 * token carries `orgRoles[orgId]` (`syncOrgMemberClaims` runs a few seconds
 * after the approval), and sending that person to an empty dashboard is the
 * failure to avoid. Any membership at all, a stale request notwithstanding,
 * keeps the person out of the waiting screen.
 */
export function shouldWaitForJoinRequest(s: {
  readonly internalAdmin: boolean;
  readonly orgRoles: Readonly<Record<string, string>> | undefined;
  readonly emailVerified: boolean;
  readonly joinRequest: JoinRequestMirror | null;
}): boolean {
  return (
    s.emailVerified &&
    !s.internalAdmin &&
    Object.keys(s.orgRoles ?? {}).length === 0 &&
    s.joinRequest !== null
  );
}

/** True once the mirror says `approved` AND the token carries that org's role. */
export function approvalHasArrived(
  orgRoles: Readonly<Record<string, string>> | undefined,
  joinRequest: JoinRequestMirror | null,
): boolean {
  return joinRequest?.status === 'approved' && !!orgRoles?.[joinRequest.orgId];
}
